import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { IconTextContainerStyle } from '../../styles/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faInfoCircle, faMap } from '@fortawesome/free-solid-svg-icons';
import { BREAKPOINTS, COLORS_BASE } from '../../utils/consts';

type MenuProps = {
  vertical?: boolean;
  onNavigate?: () => void;
};

function Menu({ vertical = false, onNavigate }: MenuProps) {
  return (
      <UnorderedListStyle vertical={vertical}>
        <ListItemStyle>
          <NavLinkStyle to="/" onClick={onNavigate}>
            <IconTextContainerStyle>
              <FontAwesomeIcon icon={faHome} />
              Home
            </IconTextContainerStyle>
          </NavLinkStyle>
        </ListItemStyle>
        <ListItemStyle>
          <NavLinkStyle to="/map" onClick={onNavigate}>
            <IconTextContainerStyle>
              <FontAwesomeIcon icon={faMap} />
              Map
            </IconTextContainerStyle>
          </NavLinkStyle>
        </ListItemStyle>
        <ListItemStyle>
          <NavLinkStyle to="/about" onClick={onNavigate}>
            <IconTextContainerStyle>
              <FontAwesomeIcon icon={faInfoCircle} />
              About
            </IconTextContainerStyle>
          </NavLinkStyle>
        </ListItemStyle>
      </UnorderedListStyle>
  );
}

export default Menu;

const UnorderedListStyle = styled.ul<{ vertical?: boolean }>(({ vertical = false }) => `
  display: flex;
  flex-direction: ${vertical ? 'column' : 'row'};
  align-items: center;
  gap: ${vertical ? '0' : '8px'};
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    width: 100%;
    align-items: ${vertical ? 'stretch' : 'center'};
  }
`)

const ListItemStyle = styled.li<{}>(() => `
  display: flex;
  align-items: center;
`)

const NavLinkStyle = styled(Link)`
  text-decoration: none;
  color: ${COLORS_BASE.BRAND.DARKER};
  padding: 20px 24px;
  border-radius: 10px;

  &:hover {
    background: ${COLORS_BASE.GREYS.LIGHTER};
  }

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    display: block;
    width: 100%;
    padding: 14px 16px;
  }
`;
